import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "Leaders", href: "/leaders" },
    { name: "Services", href: "/services" },
    { name: "Programs", href: "/programs" },
    { name: "Methodology", href: "/methodology" },
    { name: "Impact", href: "/impact" },
    { name: "Industries", href: "/industries" },
    { name: "Resources", href: "/resources" },
  ];

  const isActive = (href: string) => location.pathname === href;

  return (
    <header className="fixed top-0 w-full bg-blue-100 backdrop-blur-md z-50 shadow-subtle py-2">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className=" w-55 h-55 rounded-lg flex items-center justify-center bg-white">
              <img
                src="/images/logo.jpg"
                alt="TCLA-X Logo"
                width={50}
                height={50}
              />
            </div>
            <div className="flex flex-col">
              <span className="font-bold text-xl text-blue-500">TCLA-X</span>
              <span className="text-xs text-white-500 uppercase tracking-wide">
                Empower • Elevate • Excel
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-smooth hover:bg-white hover:text-primary ${
                  isActive(item.href)
                     ? "text-blue-100 bg-blue-700"
        : "text-black hover:text-blue-200 hover:bg-blue-700"
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center space-x-4">
        
            <Button size="sm" asChild>
              <Link to="/contact">Book Consultation</Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-md text-foreground hover:text-primary hover:bg-accent"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-border bg-blue-200">
             <div className="py-2 grid grid-cols-2 gap-2 px-3">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block px-3 py-2 rounded-md text-base font-medium transition-smooth ${
                    isActive(item.href)
                      ? "text-primary bg-primary-light"
                      : "text-foreground hover:text-primary hover:bg-accent"
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <div className="flex flex-col space-y-2 px-3 py-2">
                <Button
                  className="bg-white text-blue-600 hover:bg-gray-100"
                  size="sm"
                  asChild
                >
                  <Link to="/contact">Get Quote</Link>
                </Button>
              
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;